//
//
//
//
//
//
//
//
//
//
//
//

import {
  getSStore,
  getRoutePage,
  setSStore,
  hashQuery,
  saveToken
} from "@js/public/mUtils";

export default {
  components: {},
  methods: {},
  created() {
    this.storeNo = hashQuery("storeNo") || "";
    this.getLoginStatus()
    this.timer = setInterval(() => {
      --this.time;
      if (this.time === 0) {
        clearInterval(this.timer);
        this.toRoutePage();
        // this.getAppIds()
      }
    }, 1000);
  },
  data() {
    return {
      time: 5,
      timer: null,
      storeNo: ''
    };
  },
  methods: {
    getLoginStatus() {
      setSStore("jdLqbBag", '')
      this.$http.post("/superMoney/jdCheck", { storeNo: this.storeNo })
        .then(res => {
          if (res.code === 0) {
            if (res.body.data && res.body.data.jdCheckStatus) {
              setSStore("jdLqbBag", res.body.data.jdCheckStatus);
              if(res.body.data.jdCheckStatus !== '1') {
                saveToken(res.body.data.token);
              }
            }
          }
        });
    },
    // getAppIds() {
    //   console.log(778);
    //   this.$http.post("/wc/shareConfig",{}).then(res => {
    //     console.log(res);
    //   })
    // },
    toRoutePage() {
      if (getSStore("jdLqbBag") === '4') {
        setSStore("onlyBagNum", '2');
        this.toPage('/changeBag', {})
      } else if((getSStore("jdLqbBag") === '-1')) { 
        this.toPage("/undercarriage", {});
      } else {
        this.toPage('/changeBagClone', {})
      }
    }
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/jdDrainage.vue